export const selectRegistries = ({registry}) => registry.registries ?? [];
export const selectRegistryName = ({registry}) => registry?.name ?? '';
export const selectRegistryNote = ({registry}) => registry?.registry_note ?? '';
export const selectRegistryType = ({registry}) => registry?.registry_type ?? '';
export const selectRegistryWording = (state) =>
  selectRegistryType(state) === 'wishlist' ? 'wishlist' : 'gift registry';
export const selectRegistriesLength = (state) => selectRegistries(state).length;
export const selectHasRegistries = (state) => selectRegistriesLength(state) > 0;
export const selectHasMultipleRegistries = (state) => selectRegistriesLength(state) > 1;
